import React, {useState, useEffect, useRef} from 'react';
import {useHistory} from "react-router-dom";
import { useDispatch } from 'react-redux';
import { replayPositionsActions } from '../store';

import MainToolbar from '../MainToolbar';
import MapGoogle from '../mapGoogle/MapGoogle';
import { t } from '../common/LocalizationProvider';
import ReplayPathMapGoogle from '../mapGoogle/ReplayPathMapGoogle';
import {formatPosition, formatSpeed, formatDistance, formatDate} from '../common/formatter';
import PositionsMapGoogle from "../mapGoogle/PositionsMapGoogle";
import StartsStopsGoogleMap from "../mapGoogle/StartsStopsGoogleMap";
import ReportFilter from './ReportFilter';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Container,
    makeStyles,
    Paper,
    Slider,
    Tooltip,
    Typography, useMediaQuery,
    useTheme
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';
import FastRewindIcon from '@material-ui/icons/FastRewind';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import FastForwardIcon from '@material-ui/icons/FastForward';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles(theme => ({
    ...cyberStyles(theme),
    controlPanel: {
        position: 'absolute',
        bottom: theme.spacing(2),
        left: '50%',
        transform: 'translateX(-50%)',
    },
    configForm: {
        display: 'flex',
        flexDirection: 'column',
    },
}));

const TimeLabel = ({ children, open, value }) => {
    return (
        <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
            {children}
        </Tooltip>
    );
};

function smoothFlyTo(googleMap, targetLatLng, targetZoom, step = 0.5, delay = 50) {
    targetZoom = 17
    const currentZoom = googleMap?.getZoom?.();
    if (currentZoom) {
        // Start panning smoothly
        googleMap.panTo(targetLatLng);
        const zoomSteps = [];

        // Create zoom steps between current and target
        if (currentZoom < targetZoom) {
            for (let z = currentZoom + step; z <= targetZoom; z += step) {
                zoomSteps.push(Number(z.toFixed(1)));
            }
        } else {
            for (let z = currentZoom - step; z >= targetZoom; z -= step) {
                zoomSteps.push(Number(z.toFixed(1)));
            }
        }

        let i = 0;
        const interval = setInterval(() => {
            if (i >= zoomSteps.length) {
                clearInterval(interval);
                return;
            }
            googleMap.setZoom(zoomSteps[i]);
            i++;
        }, delay);
    }
}


const ReplayPageGoogleMap = () => {
    const classes = useStyles();
    const intervalId = useRef()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const history = useHistory();

    const [positions, setPositions] = useState([]);
    const [index, setIndex] = useState(0);
    const [playing, setPlaying] = useState(false); // Add playing state
    const [speedType, setSpeedType] = useState('Medium');
    const [distanceAccu, setDistanceAccu] = useState(0);
    const [subPositions, setSubPositions] = useState([]);
    const [expanded, setExpanded] = useState(true);
    const [stopsPositions, setStopsPositions] = useState([]);
    const [loading, setLoding] = useState(false);
    const [googleMapInstance, setGoogleMapInstance] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(null)
    const dispatch = useDispatch();

    const speedValues = {
        Slow: 500,
        Medium: 300,
        Fast: 20
    };

    useEffect(() => {
        if (positions) {
            const sliced = positions.slice(0, index+1);
            const distance = index === 0 ? 0 : positions[index].attributes.totalDistance - positions[0].attributes.totalDistance;
            setSubPositions(sliced);
            setDistanceAccu(distance);
            dispatch(replayPositionsActions.setSubPositions(sliced));
            dispatch(replayPositionsActions.setIndex(index));
            dispatch(replayPositionsActions.setDistanceAccu(distance));
        }
    }, [index, positions]);

    const handleSubmit = async (deviceIds, from, to, _, headers) => {
        const query = new URLSearchParams({ from, to });
        deviceIds.forEach(deviceId => query.append("deviceId", deviceId))

        const response = await fetch(`/api/positions?${query.toString()}`, { headers });
        if (response.ok) {
            setIndex(0);
            const res = await response.json();
            setPositions(res);
            dispatch(replayPositionsActions.setPositions(res));
            dispatch(replayPositionsActions.setIndex(0));
            if (res.length === 0)
                setOpenSnackbar('replayNoData')
            else
                setExpanded(false);
        }
        setLoding(null)
    };

    const handleStopsPositions = async (deviceIds, from, to, _, headers) => {
        if (deviceIds.length > 1)
            return;

        const mail = false;
        const query = new URLSearchParams({ from, to, mail });
        deviceIds.forEach(deviceId => query.append("deviceId", deviceId))

        const response = await fetch(`/api/reports/stops?${query.toString()}`, { headers });
        if (response.ok) {
            const contentType = response.headers.get('content-type');
            if (contentType) {
                if (contentType === 'application/json') {
                    let items = await response.json()
                    items = items.slice(1)
                    setStopsPositions(items)
                }
                else
                    window.location.assign(window.URL.createObjectURL(await response.blob()))
            }
        }
    };

    const goToPreviousPosition = () => {
        setIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
        const position = positions[index-1];
        smoothFlyTo(
            googleMapInstance.googleMap,
            { lat: position.latitude, lng: position.longitude },
            15
        );
    };

    const goToNextPosition = () => {
        setIndex((prevIndex) => (prevIndex < positions.length - 1 ? prevIndex + 1 : prevIndex));
        const position = positions[index+1];
        smoothFlyTo(
            googleMapInstance.googleMap,
            { lat: position.latitude, lng: position.longitude },
            15
        );
    };

    useEffect(() => {
        if (playing && index < positions.length - 1) {
            if (intervalId.current)
                clearInterval(intervalId.current)
            intervalId.current = setInterval(() => {setIndex((prevIndex) => (prevIndex < positions.length - 1 ? prevIndex + 1 : prevIndex));}, speedValues[speedType]);
            const position = positions[index];
            smoothFlyTo(
                googleMapInstance.googleMap,
                { lat: position.latitude, lng: position.longitude },
                15
            );
        }
        if (index === positions.length - 1) {
            setPlaying(false); // Stop playing when the last position is reached
        }
        return () => {
            clearInterval(intervalId.current);
        };
    }, [playing, index, positions, speedType]);

    const handleToggleSpeed = () => {
        // Define the order of speed types
        const speedTypes = ['Slow', 'Medium', 'Fast'];

        // Find the current index of the speed type
        const currentIndex = speedTypes.indexOf(speedType);

        // Calculate the next index (looping back to the start if at the end)
        const nextIndex = (currentIndex + 1) % speedTypes.length;

        // Update the speed type
        setSpeedType(speedTypes[nextIndex]);
    };

    return (
        <div className={classes.content} style={{padding: theme.spacing(0)}}>
            {!isMobile && <MainToolbar/>}

            <IconButton className={classes.backButtonReplay} onClick={() => history.push('/')}>
                <ArrowBackIcon className={classes.notificationIconColor} />
            </IconButton>

            <MapGoogle onMapReady={setGoogleMapInstance}>
                <ReplayPathMapGoogle />
                {index < positions.length && index !== 0 && <PositionsMapGoogle positions={[positions[index]]} replayBack={true}/>}
                {index < positions.length && <StartsStopsGoogleMap positions={positions} stops={stopsPositions} />}
            </MapGoogle>

            <Container maxWidth="sm" className={classes.controlPanel}>
                {!!positions.length &&
                    <Paper className={classes.controlContent}>
                        <Slider
                            className={classes.replaySlider}
                            max={positions.length - 1}
                            step={null}
                            marks={positions.map((_, index) => ({ value: index }))}
                            value={index}
                            onChange={(_, index) => setIndex(index)}
                            valueLabelDisplay="auto"
                            valueLabelFormat={i => i < positions.length ? formatPosition(positions[i], 'fixTime') : ''}
                            ValueLabelComponent={TimeLabel}
                        />
                        <div>
                            <div className={classes.controlsRow}>
                            <div className={classes.moreIcon}>{`${index + 1}/${positions.length}`}</div>
                            <IconButton className={classes.moreIcon} onClick={goToPreviousPosition} disabled={playing || index <= 0} >
                                <FastRewindIcon />
                            </IconButton>
                            <IconButton className={classes.moreIcon} onClick={() => setPlaying(!playing)}>
                                {playing ? <PauseIcon /> : <PlayArrowIcon />}
                            </IconButton>
                            <IconButton className={classes.moreIcon} onClick={goToNextPosition} disabled={playing || index >= positions.length - 1}>
                                <FastForwardIcon />
                            </IconButton>
                            <IconButton className={classes.moreIcon} onClick={handleToggleSpeed}>
                                <FastForwardIcon />
                                <Typography variant="body2" style={{ marginLeft: 4, fontStyle: 'italic', color: 'gray' }}>
                                    {t(speedType)}
                                </Typography>
                            </IconButton>
                            </div>
                            <Typography variant="body2" className={classes.timeDisplay}>
                                <div style={{ display: 'grid', gridAutoFlow: 'column'}}>
                                    <div>{formatDate(positions[index].fixTime)}</div>
                                    <div>{formatSpeed(positions[index].speed, "kmhFix0")}</div>
                                    <div>{formatDistance(distanceAccu, "km")}</div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </Typography>
                        </div>
                    </Paper>
                }

                <div>
                    <Accordion className={classes.accordionReplay} expanded={expanded} onChange={() => setExpanded(!expanded)}>
                        <AccordionSummary className={classes.accordionSummary} expandIcon={<ExpandMoreIcon />}>
                            <Typography align='center'>
                                {t('reportConfigure')}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={classes.configForm}>
                            <ReportFilter handleSubmit={handleSubmit} showOnly handleStopsPositions={handleStopsPositions}
                                          loading={loading} openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} setLoading={setLoding}/>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </Container>

        </div>
    );
}

export default ReplayPageGoogleMap;
